
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_1kosq_13i6w_93",
  "breadcrumb": "awsui_breadcrumb_1kosq_13i6w_97",
  "icon": "awsui_icon_1kosq_13i6w_100",
  "anchor": "awsui_anchor_1kosq_13i6w_105",
  "last": "awsui_last_1kosq_13i6w_148",
  "compressed": "awsui_compressed_1kosq_13i6w_158",
  "text": "awsui_text_1kosq_13i6w_162",
  "virtual-item": "awsui_virtual-item_1kosq_13i6w_169",
  "item-popover": "awsui_item-popover_1kosq_13i6w_176"
};
  